// モックデータ

import { Tenant, User, Project, RoutineTask, TaskInstance, ActionHistory, TaskTemplate, Task, WorkspaceMembership } from '../types';
import { calculateInitialDueDate } from './taskGenerator';

// テナント（複数ワークスペース）
export const mockTenants: Tenant[] = [
  {
    id: 'tenant-1',
    name: '株式会社サンプル',
    timezone: 'Asia/Tokyo',
    fiscalYearStartMonth: 4, // 4月始まり
    weekStartDay: 1, // 月曜始まり
    createdAt: new Date('2024-01-01'),
  },
  {
    id: 'tenant-2',
    name: 'ABC商事株式会社',
    timezone: 'Asia/Tokyo',
    fiscalYearStartMonth: 1, // 1月始まり
    weekStartDay: 1, // 月曜始まり
    createdAt: new Date('2023-06-01'),
  },
  {
    id: 'tenant-3',
    name: 'XYZコンサルティング',
    timezone: 'Asia/Tokyo',
    fiscalYearStartMonth: 4, // 4月始まり
    weekStartDay: 0, // 日曜始まり
    createdAt: new Date('2023-09-01'),
  },
];

export const mockTenant: Tenant = mockTenants[0]; // デフォルトテナント

// ワークスペースメンバーシップ
export const mockWorkspaceMemberships: WorkspaceMembership[] = [
  // 田中さん: 株式会社サンプルとABC商事に所属
  { id: 'mem-1', userId: 'user-1', tenantId: 'tenant-1', role: 'owner', joinedAt: new Date('2024-01-01') },
  { id: 'mem-2', userId: 'user-1', tenantId: 'tenant-2', role: 'member', joinedAt: new Date('2024-03-01') },
  
  // 鈴木さん: 株式会社サンプルとXYZコンサルティングに所属
  { id: 'mem-4', userId: 'user-3', tenantId: 'tenant-1', role: 'member', joinedAt: new Date('2024-01-01') },
  { id: 'mem-5', userId: 'user-3', tenantId: 'tenant-3', role: 'admin', joinedAt: new Date('2024-02-01') },
  
  // 山田さん: 株式会社サンプルのみ
  { id: 'mem-6', userId: 'user-4', tenantId: 'tenant-1', role: 'member', joinedAt: new Date('2024-01-01') },
  
  // 高橋さん: 株式会社サンプルのみ
  { id: 'mem-7', userId: 'user-5', tenantId: 'tenant-1', role: 'member', joinedAt: new Date('2024-01-01') },
  
  // ABC商事のユーザー
  { id: 'mem-8', userId: 'user-6', tenantId: 'tenant-2', role: 'owner', joinedAt: new Date('2023-06-01') },
  { id: 'mem-9', userId: 'user-7', tenantId: 'tenant-2', role: 'member', joinedAt: new Date('2023-06-01') },
  
  // XYZコンサルティングのユーザー
  { id: 'mem-10', userId: 'user-8', tenantId: 'tenant-3', role: 'owner', joinedAt: new Date('2023-09-01') },
  { id: 'mem-11', userId: 'user-9', tenantId: 'tenant-3', role: 'member', joinedAt: new Date('2023-09-01') },
];

// グループ
export const mockGroups: Group[] = [
  {
    id: 'group-1',
    tenantId: 'tenant-1',
    name: '経理部',
    description: '経理業務を担当',
    reportEmailAddresses: ['manager@example.com'],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'group-2',
    tenantId: 'tenant-1',
    name: '人事部',
    description: '人事業務を担当',
    reportEmailAddresses: ['hr-manager@example.com'],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'group-3',
    tenantId: 'tenant-1',
    name: '総務部',
    description: '総務業務を担当',
    reportEmailAddresses: ['admin-manager@example.com'],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
];

// ユーザー
export const mockUsers: User[] = [
  {
    id: 'user-1',
    tenantIds: ['tenant-1', 'tenant-2'], // 複数ワークスペースに所属
    email: 'admin@example.com',
    password: 'password', // デモ用
    name: '田中 太郎',
    role: 'admin',
    emailNotificationEnabled: true,
    createdAt: new Date('2024-01-01'),
    lastLoginAt: new Date(),
  },
  {
    id: 'user-3',
    tenantIds: ['tenant-1', 'tenant-3'], // 複数ワークスペースに所属
    email: 'suzuki@example.com',
    password: 'password', // デモ用
    name: '鈴木 一郎',
    role: 'member',
    emailNotificationEnabled: true,
    createdAt: new Date('2024-01-01'),
    lastLoginAt: new Date(),
  },
  {
    id: 'user-4',
    tenantIds: ['tenant-1'],
    email: 'yamada@example.com',
    password: 'password', // デモ用
    name: '山田 美咲',
    role: 'member',
    emailNotificationEnabled: true,
    createdAt: new Date('2024-01-01'),
    lastLoginAt: new Date(),
  },
  {
    id: 'user-5',
    tenantIds: ['tenant-1'],
    email: 'takahashi@example.com',
    password: 'password', // デモ用
    name: '高橋 健太',
    role: 'member',
    emailNotificationEnabled: true,
    createdAt: new Date('2024-01-01'),
    lastLoginAt: new Date(),
  },
  {
    id: 'user-guest-1',
    tenantIds: ['tenant-1'],
    email: 'guest@example.com',
    password: 'password', // デモ用
    name: 'ゲスト 太郎',
    role: 'guest',
    projectIds: ['project-1'], // 月次決算プロジェクトのみアクセス可能
    emailNotificationEnabled: false,
    createdAt: new Date('2024-01-01'),
    lastLoginAt: new Date(),
  },
  {
    id: 'user-6',
    tenantIds: ['tenant-2'],
    email: 'kato@example.com',
    password: 'password', // デモ用
    name: '加藤 一郎',
    role: 'admin',
    emailNotificationEnabled: true,
    createdAt: new Date('2023-06-01'),
    lastLoginAt: new Date(),
  },
  {
    id: 'user-7',
    tenantIds: ['tenant-2'],
    email: 'watanabe@example.com',
    password: 'password', // デモ用
    name: '渡辺 二郎',
    role: 'member',
    emailNotificationEnabled: true,
    createdAt: new Date('2023-06-01'),
    lastLoginAt: new Date(),
  },
  {
    id: 'user-8',
    tenantIds: ['tenant-3'],
    email: 'nakamura@example.com',
    password: 'password', // デモ用
    name: '中村 三郎',
    role: 'admin',
    emailNotificationEnabled: true,
    createdAt: new Date('2023-09-01'),
    lastLoginAt: new Date(),
  },
  {
    id: 'user-9',
    tenantIds: ['tenant-3'],
    email: 'sakamoto@example.com',
    password: 'password', // デモ用
    name: '坂本 四郎',
    role: 'member',
    emailNotificationEnabled: true,
    createdAt: new Date('2023-09-01'),
    lastLoginAt: new Date(),
  },
];

// プロジェクト
export const mockProjects: Project[] = [
  {
    id: 'project-1',
    tenantId: 'tenant-1',
    name: '月次決算業務',
    description: '月次決算に関するタスクを管理',
    memberIds: ['user-1', 'user-guest-1'],
    creatorId: 'user-1',
    isArchived: false,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'project-2',
    tenantId: 'tenant-1',
    name: '支払業務',
    description: '定期的な支払いに関するタスク',
    memberIds: ['user-1'],
    creatorId: 'user-1',
    isArchived: false,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'project-3',
    tenantId: 'tenant-1',
    name: '勤怠管理',
    description: '勤怠に関する定期業務',
    memberIds: ['user-3', 'user-4'],
    creatorId: 'user-3',
    isArchived: false,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'project-4',
    tenantId: 'tenant-1',
    name: '給与計算',
    description: '給与計算関連タスク',
    memberIds: ['user-3', 'user-4'],
    creatorId: 'user-3',
    isArchived: false,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'project-5',
    tenantId: 'tenant-1',
    name: '施設管理',
    description: 'オフィス施設の管理業務',
    memberIds: ['user-5'],
    creatorId: 'user-5',
    isArchived: false,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'project-6',
    tenantId: 'tenant-1',
    name: '2023年度決算',
    description: '完了した2023年度の決算プロジェクト',
    memberIds: ['user-1'],
    creatorId: 'user-1',
    isArchived: true,
    createdAt: new Date('2023-01-01'),
    updatedAt: new Date('2024-04-01'),
  },
];

// ルーチンタスク
export const mockRoutineTasks: RoutineTask[] = [
  {
    id: 'routine-1',
    projectId: 'project-1',
    name: '売上データ集計',
    description: '各拠点からの売上データを集計',
    repeatPattern: {
      type: 'monthly',
      initialDueDate: new Date('2024-12-05'),
    },
    assigneeIds: ['user-1'],
    isActive: true,
    creatorId: 'user-1',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-2',
    projectId: 'project-1',
    name: '経費精算チェック',
    description: '経費精算の承認と確認',
    repeatPattern: {
      type: 'weekly',
      initialDueDate: new Date('2024-11-29'), // 金曜日
    },
    assigneeIds: ['user-1'],
    isActive: true,
    creatorId: 'user-1',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-3',
    projectId: 'project-2',
    name: '家賃支払い',
    description: 'オフィス家賃の支払い処理',
    repeatPattern: {
      type: 'monthly',
      initialDueDate: new Date('2024-11-30'),
    },
    assigneeIds: ['user-1'],
    isActive: true,
    creatorId: 'user-1',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-4',
    projectId: 'project-3',
    name: '勤怠締め処理',
    description: '月次勤怠の締め処理',
    repeatPattern: {
      type: 'monthly',
      initialDueDate: new Date('2024-11-30'),
    },
    assigneeIds: ['user-3'],
    isActive: true,
    creatorId: 'user-3',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-5',
    projectId: 'project-4',
    name: '給与計算',
    description: '月次給与の計算',
    repeatPattern: {
      type: 'monthly',
      initialDueDate: new Date('2024-12-25'),
    },
    assigneeIds: ['user-4'],
    isActive: true,
    creatorId: 'user-3',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-6',
    projectId: 'project-4',
    name: '社会保険料計算',
    description: '社会保険料の計算と申告',
    repeatPattern: {
      type: 'monthly',
      initialDueDate: new Date('2024-12-10'),
    },
    assigneeIds: ['user-3'],
    isActive: true,
    creatorId: 'user-3',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-7',
    projectId: 'project-5',
    name: '清掃業者確認',
    description: '清掃業者の作業確認',
    repeatPattern: {
      type: 'weekly',
      initialDueDate: new Date('2024-11-25'), // 月曜日
    },
    assigneeIds: ['user-5'],
    isActive: true,
    creatorId: 'user-5',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-8',
    projectId: 'project-1',
    name: '日次売上チェック',
    description: '毎日の売上速報を確認',
    repeatPattern: {
      type: 'daily',
      initialDueDate: new Date('2024-11-23'), // 土曜日
    },
    assigneeIds: ['user-1'],
    isActive: true,
    creatorId: 'user-1',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-9',
    projectId: 'project-3',
    name: '日次勤怠確認',
    description: '毎日の勤怠データを確認',
    repeatPattern: {
      type: 'daily',
      initialDueDate: new Date('2024-11-23'), // 土曜日
    },
    assigneeIds: ['user-3'],
    isActive: true,
    creatorId: 'user-3',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-10',
    projectId: 'project-1',
    name: '請求書データ入力',
    description: '取引先からの請求書をシステムに入力',
    repeatPattern: {
      type: 'daily',
      initialDueDate: new Date('2024-11-23'),
    },
    assigneeIds: ['user-guest-1'], // ゲストユーザー専用の日次タスク
    isActive: true,
    creatorId: 'user-1',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-11',
    projectId: 'project-1',
    name: '仮払金確認',
    description: '仮払金の精算状況を確認',
    repeatPattern: {
      type: 'weekly',
      initialDueDate: new Date('2024-11-27'), // 水曜日
    },
    assigneeIds: ['user-guest-1'], // ゲストユーザー専用の週次タスク
    isActive: true,
    creatorId: 'user-1',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'routine-12',
    projectId: 'project-1',
    name: '11月度決算資料確認',
    description: '11月度の決算資料を確認して承認',
    repeatPattern: {
      type: 'none',
      initialDueDate: new Date('2024-12-10'), // 繰り返しなし・12月10日期限
    },
    assigneeIds: ['user-guest-1'], // ゲストユーザー専用の単発タスク
    isActive: true,
    creatorId: 'user-1',
    createdAt: new Date('2024-11-20'),
    updatedAt: new Date('2024-11-20'),
  },
  {
    id: 'routine-13',
    projectId: 'project-1',
    name: '監査資料準備',
    description: '年次監査のための必要書類を準備',
    repeatPattern: {
      type: 'none',
      initialDueDate: new Date('2024-12-15'), // 繰り返しなし・12月15日期限
    },
    assigneeIds: ['user-guest-1'], // ゲストユーザー専用の単発タスク
    isActive: true,
    creatorId: 'user-1',
    createdAt: new Date('2024-11-22'),
    updatedAt: new Date('2024-11-22'),
  },
  {
    id: 'routine-14',
    projectId: 'project-1',
    name: '取引先へ請求書送付',
    description: 'A社・B社・C社への11月分請求書を送付',
    repeatPattern: {
      type: 'none',
      initialDueDate: new Date('2024-11-30'), // 繰り返しなし・11月30日期限
    },
    assigneeIds: ['user-guest-1'], // ゲストユーザー専用の単発タスク
    isActive: true,
    creatorId: 'user-1',
    createdAt: new Date('2024-11-25'),
    updatedAt: new Date('2024-11-25'),
  },
];

// タスクインスタンスを生成
const now = new Date();

// いくつかのタスクを期限切れにするため、過去の日付を設定
const createTaskInstance = (
  id: string,
  routineTask: RoutineTask,
  daysOffset: number,
  isCompleted: boolean = false
): TaskInstance => {
  const dueDate = new Date(now);
  dueDate.setDate(dueDate.getDate() + daysOffset);
  
  const createdAt = new Date(dueDate);
  createdAt.setDate(createdAt.getDate() - 7);
  
  return {
    id,
    routineTaskId: routineTask.id,
    projectId: routineTask.projectId,
    name: routineTask.name,
    description: routineTask.description,
    occurrenceDate: createdAt,
    dueDate,
    assigneeIds: routineTask.assigneeIds,
    status: isCompleted ? 'completed' : 'pending',
    completedAt: isCompleted ? new Date(dueDate.getTime() - 86400000) : undefined,
    completerId: isCompleted ? routineTask.assigneeIds[0] : undefined,
    createdAt,
    updatedAt: createdAt,
  };
};

export const mockTaskInstances: TaskInstance[] = [
  // 期限切れタスク（赤色）
  createTaskInstance('task-1', mockRoutineTasks[0], -3, false), // 3日前が期限
  createTaskInstance('task-2', mockRoutineTasks[3], -5, false), // 5日前が期限
  createTaskInstance('task-3', mockRoutineTasks[5], -2, false), // 2日前が期限
  
  // 今日期限のタスク（オレンジ色）
  createTaskInstance('task-4', mockRoutineTasks[1], 0, false), // 今日が期限
  createTaskInstance('task-5', mockRoutineTasks[6], 0, false), // 今日が期限
  createTaskInstance('task-13', mockRoutineTasks[7], 0, false), // 日次売上チェック - 今日が期限
  
  // 今週期限のタスク（黄色）
  createTaskInstance('task-6', mockRoutineTasks[2], 3, false), // 3日後が期限
  createTaskInstance('task-7', mockRoutineTasks[4], 5, false), // 5日後が期限
  createTaskInstance('task-14', mockRoutineTasks[8], 2, false), // 日次勤怠確認 - 2日後が期限
  
  // 余裕があるタスク（緑色）
  createTaskInstance('task-8', mockRoutineTasks[0], 10, false), // 10日後が期限
  createTaskInstance('task-9', mockRoutineTasks[1], 12, false), // 12日後が期限
  
  // 完了済みタスク
  createTaskInstance('task-10', mockRoutineTasks[2], -10, true),
  createTaskInstance('task-11', mockRoutineTasks[3], -8, true),
  createTaskInstance('task-12', mockRoutineTasks[4], -7, true),
  createTaskInstance('task-15', mockRoutineTasks[7], -1, true), // 日次売上チェック - 昨日完了
  createTaskInstance('task-16', mockRoutineTasks[8], -2, true), // 日次勤怠確認 - 2日前完了
  
  // ゲストユーザー専用タスク
  createTaskInstance('task-guest-1', mockRoutineTasks[9], -1, false), // 請求書データ入力 - 昨日が期限（期限切れ）
  createTaskInstance('task-guest-2', mockRoutineTasks[9], 0, false), // 請求書データ入力 - 今日が期限
  createTaskInstance('task-guest-3', mockRoutineTasks[10], 1, false), // 仮払金確認 - 明日が期限
  createTaskInstance('task-guest-4', mockRoutineTasks[9], -3, true), // 請求書データ入力 - 3日前に完了
  createTaskInstance('task-guest-5', mockRoutineTasks[10], -7, true), // 仮払金確認 - 1週間前に完了
  
  // ゲストユーザー専用の繰り返しなしタスク（単発タスク）
  createTaskInstance('task-guest-6', mockRoutineTasks[11], 16, false), // 11月度決算資料確認 - 12/10期限（16日後）
  createTaskInstance('task-guest-7', mockRoutineTasks[12], 21, false), // 監査資料準備 - 12/15期限（21日後）
  createTaskInstance('task-guest-8', mockRoutineTasks[13], 6, false), // 取引先へ請求書送付 - 11/30期限（6日後）
];

// アクションヒストリー
export const mockActionHistory: ActionHistory[] = [
  {
    id: 'action-1',
    tenantId: 'tenant-1',
    targetType: 'task_instance',
    targetId: 'task-10',
    actionType: 'completed',
    executorId: 'user-1',
    executedAt: new Date(now.getTime() - 10 * 86400000),
  },
  {
    id: 'action-2',
    tenantId: 'tenant-1',
    targetType: 'task_instance',
    targetId: 'task-11',
    actionType: 'completed',
    executorId: 'user-3',
    executedAt: new Date(now.getTime() - 8 * 86400000),
  },
  {
    id: 'action-3',
    tenantId: 'tenant-1',
    targetType: 'task_instance',
    targetId: 'task-12',
    actionType: 'completed',
    executorId: 'user-4',
    executedAt: new Date(now.getTime() - 7 * 86400000),
  },
];

// タスクテンプレート
export const mockTaskTemplates: TaskTemplate[] = [
  {
    id: 'template-1',
    workspaceId: 'tenant-1',
    name: '月次決算業務テンプレート',
    description: '月次決算に必要な標準的なタスクセット',
    tasks: [
      {
        id: 'task-1-1',
        workspaceId: 'tenant-1',
        name: '売上データ集計',
        description: '各拠点からの売上データを集計',
        recurrence: { type: 'monthly', dayOfMonth: 5 },
        daysUntilDue: 3,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-1-2',
        workspaceId: 'tenant-1',
        name: '仕入データ集計',
        description: '仕入データの集計と確認',
        recurrence: { type: 'monthly', dayOfMonth: 5 },
        daysUntilDue: 3,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-1-3',
        workspaceId: 'tenant-1',
        name: '経費精算チェック',
        description: '経費精算の承認と確認',
        recurrence: { type: 'monthly', dayOfMonth: 10 },
        daysUntilDue: 5,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-1-4',
        workspaceId: 'tenant-1',
        name: '残高確認',
        description: '銀行残高と帳簿残高の照合',
        recurrence: { type: 'monthly', dayOfMonth: 15 },
        daysUntilDue: 2,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-1-5',
        workspaceId: 'tenant-1',
        name: '月次決算資料作成',
        description: '月次決算レポートの作成',
        recurrence: { type: 'monthly', dayOfMonth: 20 },
        daysUntilDue: 5,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
    ],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'template-2',
    workspaceId: 'tenant-1',
    name: '給与計算業務テンプレート',
    description: '給与計算に必要な標準的なタスクセット',
    tasks: [
      {
        id: 'task-2-1',
        workspaceId: 'tenant-1',
        name: '勤怠データ確認',
        description: '勤怠データの集計と確認',
        recurrence: { type: 'monthly', dayOfMonth: 25 },
        daysUntilDue: 2,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-2-2',
        workspaceId: 'tenant-1',
        name: '残業時間集計',
        description: '残業時間の集計と確認',
        recurrence: { type: 'monthly', dayOfMonth: 25 },
        daysUntilDue: 1,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-2-3',
        workspaceId: 'tenant-1',
        name: '給与計算',
        description: '月次給与の計算',
        recurrence: { type: 'monthly', dayOfMonth: 20 },
        daysUntilDue: 3,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-2-4',
        workspaceId: 'tenant-1',
        name: '給与明細作成',
        description: '給与明細の作成と配布',
        recurrence: { type: 'monthly', dayOfMonth: 23 },
        daysUntilDue: 2,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-2-5',
        workspaceId: 'tenant-1',
        name: '給与振込処理',
        description: '給与の振込処理',
        recurrence: { type: 'monthly', dayOfMonth: 25 },
        daysUntilDue: 1,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
    ],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'template-3',
    workspaceId: 'tenant-1',
    name: '週次業務テンプレート',
    description: '週次で行う標準的なタスクセット',
    tasks: [
      {
        id: 'task-3-1',
        workspaceId: 'tenant-1',
        name: '週次報告書作成',
        description: '週次の業務報告書を作成',
        recurrence: { type: 'weekly', dayOfWeek: 5 },
        daysUntilDue: 1,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-3-2',
        workspaceId: 'tenant-1',
        name: '在庫確認',
        description: '週次での在庫チェック',
        recurrence: { type: 'weekly', dayOfWeek: 1 },
        daysUntilDue: 2,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-3-3',
        workspaceId: 'tenant-1',
        name: 'ミーティング議事録作成',
        description: '週次ミーティングの議事録作成',
        recurrence: { type: 'weekly', dayOfWeek: 5 },
        daysUntilDue: 1,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
    ],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'template-4',
    workspaceId: 'tenant-2',
    name: '営業報告テンプレート',
    description: '営業活動の報告に関するタスク',
    tasks: [
      {
        id: 'task-4-1',
        workspaceId: 'tenant-2',
        name: '営業日報作成',
        description: '日次の営業活動報告',
        recurrence: { type: 'daily' },
        daysUntilDue: 1,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
      {
        id: 'task-4-2',
        workspaceId: 'tenant-2',
        name: '週次営業会議資料作成',
        description: '週次営業会議用の資料作成',
        recurrence: { type: 'weekly', dayOfWeek: 4 },
        daysUntilDue: 2,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
    ],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
];